import { PageMajorHeading } from '@components/buzzkuri/shared/uiParts/heading/PageMajorHeading'
import { ProgramThumbnail } from '@type/buzzkuri/common'
import { Objective } from '@type/buzzkuri/home'
import { ProgramLabel } from '@type/buzzkuri/programs'
import React from 'react'
import { FindFromTarget } from './FindFromTarget'
import { IntroductionCompanies } from '../IntroductionCompanies'
import { RecommendGenre } from './RecommendGenre'
import { TrainingPrograms } from './TrainingPrograms'

type Props = {
  popularPrograms: ProgramThumbnail[]
  newPrograms: ProgramThumbnail[]
  objectives: Objective[]
  recommendTags: ProgramLabel[]
}
//
export const FindTrainingProgramSection = ({
  // popularPrograms,
  // newPrograms,
  objectives,
  recommendTags,
}: Props): JSX.Element => {
  return (
    <section>
      <PageMajorHeading
        mainHeading="プログラム(対面/オンライン)を探す"
        MainHeadingTag="h1"
      />
      <div className="mt-[6vw] lg:mt-[2.6vw]">
        <RecommendGenre {...{ recommendTags }} />
      </div>

      <div className="mt-[10.3vw] lg:mt-[4.5vw]">
        <FindFromTarget {...{ objectives }} />
      </div>
      <TrainingPrograms />

      <div className="mt-[10.3vw] lg:mt-[4.5vw]">
        <IntroductionCompanies />
      </div>
    </section>
  )
}
